import { DoNothingStep } from "@redotech/redo-flows-common/steps";
import { FrontendStepType, PartialWithRequiredType } from "../steps";

export const doNothingStepType: FrontendStepType<
  PartialWithRequiredType<DoNothingStep>
> = {
  type: "standard",
  valid: (_) => true,
  selectable: (_) => false, // End nodes are not selectable
  inspectorFactory: (_) => ({ sections: [] }),
};
